exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-header{position:relative;text-align:center;padding-top:6.5rem;padding-bottom:0}@media (min-width:48em){.section-header{padding-top:8.5rem;padding-bottom:0}}@media (min-width:76.8em){.section-header{padding-top:15rem;padding-bottom:0}}@media (min-width:99.2em){.section-header{padding-top:17.5rem;padding-bottom:0}}.section-header .number-hldr{display:none}@media (min-width:48em){.section-header .number-hldr{display:flex;margin-right:16.66667%;margin-bottom:0;padding-right:2.4rem}}.section-header .number-hldr .nunber-title{color:#4d4d4d;border-bottom-color:#4d4d4d}.section-header .title-hldr .title{color:#d94c02;border-bottom-color:#d94c02;text-align:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-SectionHeader/_index.scss
 ** module id = 199
 ** module chunks = 0
 **/